const newCustomer = {
  snackbar: "Su actualizacion esta completada",
  name: "Nombre de la Compañía",
  save: "Guardar",
  cancel: "Cancelar",
  area: "Compañía",
  formTitle: "Nuevo Compañía",
  confirm: "¿Estás seguro de querer eliminar este elemento?",
  close: "Cerrar",
  delete: "Eliminar"
};
export default newCustomer;
